import Model from "./Model";

export const SituacaoSerieType = {
  ATIVA: 1,
  DESATIVADA: 0,
};

export default class Serie extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }

  get ativa() {
    return this.situacao === SituacaoSerieType.ATIVA;
  }

  get desativada() {
    return this.situacao === SituacaoSerieType.DESATIVADA;
  }
}
